import { render, staticRenderFns } from "./AppBarPages.vue?vue&type=template&id=fc33d39c&"
import script from "./AppBarPages.vue?vue&type=script&lang=js&"
export * from "./AppBarPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc33d39c')) {
      api.createRecord('fc33d39c', component.options)
    } else {
      api.reload('fc33d39c', component.options)
    }
    module.hot.accept("./AppBarPages.vue?vue&type=template&id=fc33d39c&", function () {
      api.rerender('fc33d39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/AppBarPages.vue"
export default component.exports